import React, { useState, useEffect } from 'react';

import { useQuery } from '@apollo/react-hooks';
import { List, Checkbox } from 'antd';
import axios from 'axios';

import { queries } from '../../graphql/graphql';

export const Specifications = ({ templateId, value, onChange, typeform, ...rest }) => {
  const [fields, setFields] = useState([]);
  // let loading;
  let data = {};
  let template = [];
  let typeformId;

  if (!typeform) {
    const response = useQuery(queries.TEMPLATE, {
      variables: { id: templateId }
    });
    // loading = response.loading;
    data = response.data;
    template = data.template;
    typeformId = template.typeformId;
  } else {
    typeformId = typeform.typeformId;
  }

  useEffect(() => {
    if (typeformId) {
      axios({
        method: 'post',
        url: '/api/typeform/form',
        data: {
          uid: typeformId
        }
      }).then(function(response) {
        if (response.status === 200) {
          setFields(response.data.fields);
        } else {
          console.log(response);
        }
      });
    }
  }, [typeform]);

  const checked = item => {
    const findItems = value.find(v => v.id === item.id);
    return !!findItems;
  };

  const onCheck = (e, item) => {
    if (!e.target.checked && checked(item)) {
      const specs = [...value];
      const Idx = specs.findIndex(s => s.id === item.id);
      if (Idx >= 0) {
        specs.splice(Idx, 1);
        onChange(specs);
      }
    } else if (e.target.checked && !checked(item)) {
      onChange([...value, { id: item.id, type: item.type, title: item.title }]);
    }
  };

  const getActions = item => {
    return [<Checkbox key={item.id} checked={checked(item)} onChange={e => onCheck(e, item)} />];
  };

  return (
    <>
      <List
        itemLayout="horizontal"
        dataSource={fields}
        renderItem={item => (
          <List.Item actions={getActions(item)}>
            <List.Item.Meta title={item.title} description={item.type} actions />
          </List.Item>
        )}
      />
    </>
  );
};
